import { render } from "./YapilacaklarDetayView.vue?vue&type=template&id=08bb7216"
import script from "./YapilacaklarDetayView.vue?vue&type=script&lang=js"
export * from "./YapilacaklarDetayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__